<template>
  <div>
    <h2 class="text-left alert alert-success">
      Client Details
    </h2>
    <dl class="dl-horizontal">
      <dt>Client Code</dt>
      <dd>{{ model.client_code || '-' }}</dd>

      <dt>Company</dt>
      <dd>{{ model.company || '-' }}</dd>

      <dt>Name</dt>
      <dd>{{ model.full_name || '-' }}</dd>

      <dt>Farm Group Name</dt>
      <dd>{{ model.farm_group_name || '-' }}</dd>

      <dt>Previous Consult Year</dt>
      <dd>{{ model.previous_winter_consult_year || '-' }}</dd>

      <dt>Zone</dt>
      <dd>{{ model.zone || '-' }}</dd>

      <dt>Address</dt>
      <dd>{{ model.full_address || '-' }}</dd>

      <dt>Phone</dt>
      <dd>{{ model.phone || '-'  }}</dd>

      <dt>Mobile</dt>
      <dd>{{ model.mobile || '-' }}</dd>

      <dt>E-Mail</dt>
      <dd>{{ model.email || '-' }}</dd>

      <dt>Pref. Contact Method</dt>
      <dd>{{ model.pref_contact_method || '-' }}</dd>

      <dt>Client Type</dt>
      <dd>{{ model.contact_bp_type || '-' }}</dd>

      <dt>Preferred Invoice Delivery</dt>
      <dd>{{ model.contact_bp_pref_inv_deliv_method || '-' }}</dd>

      <dt>Wants Report</dt>
      <dd>{{ model.contact_bp_wants_reports || '-' }}</dd>

      <dt>Promotional Consent</dt>
      <dd>{{ model.promotional_consent || '-' }}</dd>

      <dt>Keyvets</dt>
      <dd>{{ model.vision_keyvets || '-' }}</dd>
    </dl>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'ClientDetails',
  mixins: [mixin],
};
</script>
